import React from "react";

import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type HelpButtonProps = {
  url: string;
};

export const HelpButton: React.FC<HelpButtonProps> = ({ url }) => {
  return (
    <Tooltip placement="top" title="View documentation">
      <a href={url} rel="noreferrer" target="_blank">
        <Icon icon={faQuestionCircle} size="xs" />
      </a>
    </Tooltip>
  );
};
